import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="696.961"
      height="531.553"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 696.961 531.553"
      xmlSpace="preserve"
      className='clickable'
    >
      <clipPath id="ArtboardFrame">
        <path d="M0 0H2800V2160H0z"></path>
      </clipPath>
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#ArtboardFrame)"
        transform="translate(4.103 -485.737)"
      >
        <path
          strokeWidth="5"
          d="M92.796 652.314c6.59 7.696 12.08 11.752 21.309 13.808 1.702.379 10.098.843 13.245-.36 3.297-1.26 3.505-2.699 4.36-4.115.982-1.627.482-6.695 2.507-9.238.812-1.02 1.858-.493 2.218-2.742.471-2.949-1.989-6.003-.515-8.819 1.078-2.061 2.906-2.032 4.213-5.952.832-2.495.495-5.022 2.154-7.357.623-.877 2.035-1.699 3.266-2.84 1.08-1 1.669-2.346 1.451-3.356-1.132-5.227-2.955-9.355-3.334-15.219-.456-7.037-.626-13.916-.865-21.085-.35-10.478-1.335-22.637-8.115-31.339-7.653-9.823-20.109-14.541-24.338-17.29-4.496-2.924-27.166-9.554-32.85-9.5-5.869.056-12.832 2.886-16.431 5.257-6.54 4.308-8.597 4.21-15.95 14.003-2.834 3.775-7.686 13.228-9.956 17.332-3.137 5.673-5.67 10.836-9.28 16.163-5.501 8.116-12.145 16.391-17.748 23.854-1.964 2.617-9.812 12.166-9.745 12.007"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M113.783 666.681c-.342-.274 5.566 6.211 5.366 18.001-.17 10.009-2.818 19.679-4.884 29.337-4.386 20.501-9.582 35.212-12.774 58.076-1.097 7.859-1.47 14.937-2.237 23.931-.53 6.206-.952 12.528-1.502 19.436"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M64.671 698.53c-13.517 27.035-12.254 55.776-10.138 85.406 1.158 16.208 1.393 32.173 3.687 48.232 2.39 16.727 2.56 22.37 7.337 40.566"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M40.702 777.487c.27 2.701-42.758 57.52-44.986 57.744"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M11.478 820.317c16.86 12.051 34.9 14.534 45.608 20.293"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M-5.755 936.31c.718.359 11.71-3.328 15.867-4.703 6.777-2.242 12.35-4.049 18.927-7.211 10.855-5.219 11.451-6.395 20.916-11.222 5.47-2.79 5.142-2.873 10.499-4.652"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M16.189 814.231s2.443-2.393 4.597-3.567c2.154-1.174 2.244-1.277 4.02-1.128 1.99.168 3.792 2.384 6.943 2.867 2.033.311 1.763.669 3.85 1.039 2.086.37 1.714.309 3.759.496 2.045.188 2.051-.088 3.901.317 1.85.404 1.734.228 4.235 1.246 1.756.715 1.9.838 3.176 1.855 1.277 1.016 3.15 3.648 3.893 4.748.743 1.1 1.01 1.864 1.01 1.864"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M232.136 854.562c3.342.605 6.287 1.791 10.814 4.17 3.693 1.941 8.64 3.313 10.998 3.093 2.359-.22 6.839-3.013 8.495-5.544 4.037-6.171 11.066-13.332 13.865-15.745 2.8-2.414 7.501-6.414 11.661-8.55 9.408-4.829 24.562-8.287 36.107-11.826 11.545-3.54 13.302-4.298 21.364-7.248 8.062-2.949 16.418-6.614 22.844-8.862 5.651-1.977 18.823-3.799 24.43-8.136 2.097-5.192 1.618-13.979 1.618-13.979s-.662-15.358-2.53-34.488c-1.899-19.453-2.969-42.199-2.969-42.199s-1.127-47.704 1.011-69.337c.681-6.899.603-11.142 1.749-13.835 1.667-3.916 3.37-6.593 7.583-8.76 3.589-1.846 11.528-3.702 18.152-5.68 2.873-.859 6.292-1.508 8.949-2.641 3.467-1.478 4.342-2.049 6.162-4.003 1.82-1.955-.238-5.632 1.394-10.093 1.335-3.649 1.542-4.57 2.968-6.996 1.426-2.425 2.43-4.727 4.988-7.233 2.419-2.369 2.622-2.209 3.462-5.987.478-2.15-1.362-5.887-3.145-10.308-1.783-4.42-5.667-9.004-7.264-15.313-1.49-5.89-.599-11.425 1.644-19.933 1.88-7.129 3.684-11.675 8.156-18.86 3.724-5.983 11.699-12.276 14.452-13.835 2.773-1.57 9.309-4.441 18.758-4.18 7.087.195 11.107 1.066 17.201 3.796 6.016 2.695 9.295 6.587 13.915 11.634 4.495 4.911 7.061 9.148 10.366 15.466 3.263 6.236 4.259 12.064 6.376 19.016 2.116 6.952 1.955 8.844 4.609 16.518 1.912 5.53 4.544 11.685 10.695 17.957 4.643 4.734 11.037 8.425 18.755 11.805 5.916 2.591 7.738 2.365 12.029 6.182 3.762 3.348 6.676 12.1 8.559 20.462 1.786 7.933 3.087 13.785 3.892 24.413.804 10.627-1.27 25.91-5.791 42.278-4.23 15.311-5.235 19.999-9.444 28.787-2.724 5.688-5.003 7.266-5.599 14.123-.541 6.214 1.993 12.374 6.06 17.622 3.926 5.066 5.33 6.203 6.681 5.792 10.403-11.443 22.991-39.839 36.486-59.254 12.851-18.489 15.319-19.774 20.575-23.888 5.558-4.351 14.248-5.715 20.131-5.32 4.282.288 9.628-.162 13.865 3.319 8.873 7.289 13.936 17.118 15.481 21.228 5.777 15.365 5.656 23.31 5.477 43.604-.136 15.341-1.646 24.323-3.203 35.163-1.737 12.092-3.801 26.449-9.58 53.525-1.572 7.365-4.803 16.594-6.967 23.575-3.654 11.789-3.008 13.277-4.171 20.793-1.305 8.439-1.464 12.157.634 21.75 1.875 8.576 3.21 14.072 5.988 22.644 2.779 8.572 10.54 19.61 10.54 19.61s2.127 2.583 3.234 5.377c1.108 2.795.104 2.936 1.195 5.801s1.931 2.921 3.169 5.66c3.121 6.907.744 9.059-6.197 10.669-5.337 1.238-20.586 1.93-29.513-1.074-8.928-3.004-5.844-15.986-8.47-23.475-2.626-7.489-1.831-8.612-4.2-14.596-2.369-5.985-5.277-9.343-5.277-9.343s-3.133-2.717-5.178-6.368c-2.046-3.651-2.207-4.226-3.002-8.236-.796-4.011-1.638-4.954-.179-7.805 1.459-2.85 6.815-.261 10.378-9.463.842-2.175 3.902-12.811 3.617-26.417-.494-23.571-4.823-44.558-7.442-65.872-2.619-21.315-3.516-30.81-4.487-43.599-.972-12.788 4.812-22.503 4.812-22.503"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M566.802 710.59c-2.83 1.843.086 4.825-11.749 4.5-11.835-.324-24.469-.249-37.852-3.994-13.382-3.746-18.126-5.543-37.551-15.58-19.425-10.038-30.412-7.029-40.149-24.569-8.927-16.082-2.656-26.503-6.901-40.435-4.244-13.932-10.077-15.293-10.077-15.293s-.756-3.303.769-4.017c1.526-.715 2.81.016 4.552-.449 1.742-.465 2.416-1.41 2.416-1.41s.917-.302 2.933-.48c2.016-.177 8.744.72 11.404 8.569 2.66 7.848 2.898 8.32 2.932 19.039.034 10.72-1.529 15.441.45 22.189 1.979 6.748-2.162 3.385 9.458 7.285 11.619 3.9 17.19 6.155 37.019 8.315 19.829 2.161 38.85 4.91 42.296.326 5.217-6.938 2.995-25.613 4.935-42.44 1.692-14.669-.496-16.457-.496-16.457"
          opacity="1"
        ></path>
        <path strokeWidth="5" d="M278.047 1014.45l27.735.34" opacity="1"></path>
        <path
          strokeWidth="5"
          d="M279.658 975.097s8.803 10.375 19.81 13.12c11.006 2.745 24.217-2.14 24.217-2.14"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M259.43 971.57s11.43 3.002 18.815 2.413c7.385-.59 8.787-1.493 10.724-4.771 1.937-3.278-.97-8.328-.97-8.328"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M335.767 967.524s-11.486.252-23.951-1.301c-12.466-1.553-24.891-6.15-24.891-6.15s-10.272-3.572-16.52-11.01c-6.247-7.439-8.208-22.284-8.208-22.284"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M575.778 744.435s-16.541 17.135-26.965 32.221c-10.423 15.085-14.825 34.23-14.825 34.23"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M635.554 787.204s-1.536 9.474-7.553 22.634c-2.368 5.181-6.737 12.207-10.007 17.526-6.162 10.022-13.434 16.919-20.074 24.639-2.282 2.652-4.676 4.068-6.366 5.737-1.965 1.941-3.042 4.004-2.892 5.338.104.93 2.587 2.12 6.366 3.136 2.859.767 6.59 1.238 9.845 2.54 7.939 3.174 6.977 5.623 14.757 6.904 6.977 1.15 7.539 1.86 7.539 1.86"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M664.803 877.061s1.956 5.427 8.772 7.194c9.041 2.344 15.949 5.411 21.139 15.019 5.191 9.607 1.452 30.1-7.951 28.649"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M645.234 930.678s-27.634-.749-52.832-2.489a2448.69 2448.69 0 01-48.368-3.865"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M471.746 609.032s-8.649 2.323-13.679 9.365c-5.031 7.043-8.417 17.039-8.417 17.039"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M439.74 674.877s16.463 47.707 25.528 73.411c9.065 25.703 6.068 37.806 18.736 53.4 3.238 3.986 5.729 5.548 8.547 7.648 3.361 2.505 7.035 5.445 10.906 9.664 7.116 7.756 2.24 8.484 9.01 13.709 22.976 17.733 74.183 29.246 74.183 29.246"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M240.728 898.615c2.65-1.006 6.192-4.679 8.123-6.776 11.772-12.779 5.43-14.204.631-26.848"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M402.136 785.871c13.16-13.242 30.784-11.509 45.523-2.194 4.833 3.055 10.542 6.252 14.967 9.873.945.774 7.862 5.706 7.997 5.296"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M440.942 817.275c-1.218.607 3.978 2.599 5.114.802 1.511-2.391-4.194-1.26-5.114-.802z"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M493.681 753.739c-.666-.64-1.724 4.506-.223 5.579 1.37.979 1.352-4.492.223-5.579z"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M481.366 640.493s-1.846 5.779-1.974 12.298c-.127 6.52 1.466 13.779 1.466 13.779"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M508.871 637.551c-1.61.431-3.263.584-4.418 2.417-3.099 4.917 2.505 11.123 7.591 7.509 3.93-2.793 2.038-11.324-3.173-9.926z"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M509.065 642.014l-.205-.034-.222.067-.035.206-.087.512.153.343.291.154.342-.153.087-.513-.033-.427-.171-.24v0"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M507.425 569.667c.544 1.88 1.67 9.194 1.67 9.194s2.251 7.835 7.08 10.429c4.829 2.595 14.113-.222 14.113-.222s21.96-4.469 25.212-4.272"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M135.801 567.873c-1.54.079-6.2 8.25-7.993 9.699-9.026 7.297-17.745 15.84-20.715 27.595-1.929 7.638-.359 21.357-8.646 25.707"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M97.073 623.592c-1.364.533-6.308 16.18-9.91 19.288-6.971 6.018-16.782 7.513-24.788 11.961-11.37 6.317-18.264 20.773-27.493 29.678"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M68.856 640.407c-2.77 1.083-10.22 9.96-13.797 12.535-10.935 7.87-23.462 14.436-32.569 24.524C12.438 688.6 6.205 703.298-1.953 715.811"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M12.733 659.182c6.03-13.776 19.34-24.732 26.17-38.567 10.732-21.741 16.135-45.459 29.047-65.986"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M45.676 641.992c2.13.932 15.052-18.767 16.235-21.082 11.522-22.541 18.546-55.909 43.235-68.248"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M348.246 928.976c.05.004-7.185-.669-8.848-1.006-4.688-.952-10.11-2.334-13.68-5.461"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M340.421 882.119c2.37 6.218 14.909 3.53 12.908-3.487-2.502-8.768-15.133-2.353-12.908 3.487z"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M346.298 880.372c.044.232.221.287.475.235 3.572-.737-1.022-3.17-.475-.235z"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M322.277 858.049c9.057-4.529 18.418-10.161 28.887-10.161"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M502.912 899.059c7.569-15.692 7.655-27.53 8.592-44.665"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M-253.55 368.736l-4.015-2.081"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M291.013 833.086c-.873.097.894 1.262 1.137 1.351 2.732 1.005 10.705-3.13 7.629-4.942"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M470.807 599.601l1.104 9.296"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M446.965 563.399c4.533 8.205 17.936 33.195 26.235 35.588"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M473.666 599.121c6.278.936 12.634 1.052 17.28-3.992"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M491.506 594.585c1.033-1.339 2.105-2.736 3.05-4.111"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M495.637 589.173c7.337-7.968 13.404-22.183 12.957-33.061"
          opacity="1"
        ></path>
        <path strokeWidth="1" d="M446.132 564.164l-.034.21" opacity="1"></path>
        <path
          strokeWidth="1"
          d="M446.01 564.252c-1.155-3.691.369-8.366.555-12.114.893-17.956-3.369-32.07 17.133-38.486"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M464.548 511.737c.884-5.469 2.962-10.97 3.847-16.442"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M466.081 513.605c1.236-1.716 10.192.721 11.785 1.258 7.726 2.608 21.937 25.191 28.389 24.14"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M488.78 520.84c7.526 5.419 19.507 22.757 22.99 31.475 2.459 6.155 3.873 11.535 10.911 12.673"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M508.515 571.769c3.358.543 7.926-5.597 8.408-8.576"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M528.961 558.876c-1.313.947-2.487 1.668-3.685 2.752-1.05.95-2.072 2.359-2.752 3.659-3.385 6.469 13.12.661 8.932-5.144"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M524.574 568.642c-.636-.102-.12 1.286-.096 1.929.056 1.506-.963 4.223-1.463 5.704-1.702 5.043-5.424 8.023-8.32 12.046"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M56.13 907.706c-2.262 1.91-11.466-.308-14.632-.109-12.581.792-29.538 3.941-41.93 1.091"
          opacity="1"
        ></path>
        <path strokeWidth="1" d="M2167.77-838.468v5.116" opacity="1"></path>
      </g>
    </svg>
  );
}

export default Icon;